// import { Navigate, Outlet } from 'react-router-dom';
// import { isAuthenticated } from './auth';

// const ProtectedRoute = () => {
//   if (!isAuthenticated()) {
//     return <Navigate to="/login" replace />;
//   }

//   return <Outlet />;
// };

// // import { useLocation } from 'react-router-dom';

// // const location = useLocation();

// // return (
// //   <Navigate
// //     to="/login"
// //     replace
// //     state={{ from: location.pathname }}
// //   />
// // );


// export default ProtectedRoute;

import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { isAuthenticated } from './auth';

const ProtectedRoute = () => {
  const location = useLocation();

  if (!isAuthenticated()) {
    return (
      <Navigate
        to="/"
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  return <Outlet />;
};

export default ProtectedRoute;


